import { render, staticRenderFns } from "./GeofenceTable.vue?vue&type=template&id=070bea46&scoped=true&lang=pug"
import script from "./GeofenceTable.vue?vue&type=script&lang=js"
export * from "./GeofenceTable.vue?vue&type=script&lang=js"
import style0 from "./GeofenceTable.vue?vue&type=style&index=0&id=070bea46&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070bea46",
  null
  
)

export default component.exports